// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4a47af3","455":"819e335e"}[chunkId] + ".chunk.js";
};